import { module } from "../app";
import { safeApply } from "../services/safeApply";

module.directive("dropdownMenu", function ($rootScope, $window, $animate) {
  return {
    restrict: "E",
    templateUrl: "views/templates/dropdown.html",
    scope: {
      placeholder: "@",
      list: "=",
      selected: "=?",
      onSelectionChange: "&",
      onSelectedChanged: "&",
      onItemSelected: "&",
      onItemDeselected: "&",
      selectMode: "=",
      property: "@",
      key: "@",
      displayProperty: "@?",
      icon: "@",
      hideOtherDropdown: '=?',
      dropdownHeight: '=?',
      showCaret: '=?',
      alwaysPlaceholder: '=?',
      boldPlaceholder: '=?',
      disabled: '=?',
      emptyValue: '=?',
      isMultiSelect: '=?',
      width: '=?',
      hideCleanButton: '=?',
      hideSelectedValue: '=?',
      dropdownClass: "@",
      inputHeight: '=?',
    },
    require: '?ngModel',
    link: function (scope, element, ngModel) {
      scope.model = {
        selected: scope.selected,
        hideSelectedValue: scope.hideSelectedValue
      };

      scope.shouldEnableSearch = function() {
        return scope.list && scope.list.length >= 10;
      };

      scope.isSelectionResolved = function () {
        const value = scope.model.selected;
        if (value === null || value === undefined || value === '' || value === scope.emptyValue) {
          return false;
        }
        if (!Array.isArray(scope.list)) {
          return false;
        }
        return scope.list.some(function (option) {
          const optionValue = scope.key ? option[scope.key] : option;
          return String(optionValue) === String(value);
        });
      };

      let firstPart = Math.random().toString(36).substring(7);
      const className = firstPart + "-dropdown-menu-" + new Date().getTime();

      if (scope.emptyValue === undefined) {
        scope.emptyValue = '';
      }

      if (scope.model.selected === null
        || scope.model.selected === undefined) {
        scope.model.selected = scope.emptyValue;
      }

      if (scope.isMultiSelect) {
        scope.selectedItems = [];
        scope.multiSelectEvents = {
          onSelectionChanged: ($event) => {
            scope.model.selected = scope.selectedItems.map((elem) => elem[scope.key]).join(", ");
          },
          onItemDeselect: ($event) => {
            if (scope.onItemDeselected) {
              scope.onItemDeselected({ $type: $event });
            }
            
            scope.selected = scope.selectedItems.map((elem) => elem[scope.key]).join(", ");
          },
          onItemSelect: ($event) => {
            if (scope.onItemSelected) {
              scope.onItemSelected({ $type: $event });
            }
  
            scope.selected = scope.selectedItems.map((elem) => elem[scope.key]).join(", ");
          }
        };
        scope.multiselectSettings = {
          scrollableHeight: '200px',
          scrollable: true,
          dynamicTitle: true,
          showCheckAll: false,
          showUncheckAll: false,
          enableSearch: false,
          checkBoxes: true,
          displayProp: scope.property,
          idProperty: scope.key,
          smartButtonTextProvider(selectionArray) {
            const selectedValues = selectionArray.map((elem) => elem[scope.property]).join(", ");
            let cb = scope.onSelectionChange;
            if (cb) {
              cb({ $type: selectedValues });
            }
            return selectedValues;
          },
          template: `{{option.${scope.property}}}`,
        };
        if (scope.model.selected && scope.model.selected !== scope.emptyValue) {
          const selectedKeys = String(scope.model.selected).split(',');
          scope.selectedItems = scope.list.filter(item => 
            selectedKeys.some(selectedKey => selectedKey.trim() === String(item[scope.key]).trim())
          );
          scope.multiSelectEvents.onSelectionChanged();
        }
        scope.dropdownMultiSelectText = {
          buttonDefaultText: scope.placeholder
        };
      }

      $(element).addClass(className);

      scope.isSeparator = (item) =>
        (item[scope.property] && typeof item[scope.property] == 'string' && (item[scope.property].indexOf('----') > -1 || item[scope.property].indexOf('\\-') > -1)) || !!item["separator"];

      scope.customFilter = function(searchText) {
        return function(item) {
          if (!searchText || searchText.length === 0) {
            return true;
          }
          
          if (!item) {
            return false;
          }
          
          const searchLower = searchText.toLowerCase();
          
          if (scope.property) {
            const itemValue = item[scope.property];
            if (itemValue === null || itemValue === undefined) {
              return false;
            }
            return String(itemValue).toLowerCase().indexOf(searchLower) > -1;
          } else {
            if (item === null || item === undefined) {
              return false;
            }
            return String(item).toLowerCase().indexOf(searchLower) > -1;
          }
        };
      };

      scope.onSelectedChange = ($item, $model) => {
        scope.model.selected = $model;
        if (scope.model.selected === null
          || scope.model.selected === undefined) {
          scope.model.selected = scope.emptyValue;
        }

        if (scope.selected !== scope.model.selected){
          scope.selected = scope.model.selected;
        }

        let cb = scope.onSelectionChange;
        if (cb) {
          cb({ $type: scope.model.selected });
        }
      };

      scope.resetSelectedClick = ($event, $select) => {
        if (scope.disabled === true) {
          return;
        }

        scope.model.selected = scope.emptyValue;
        if (scope.isMultiSelect) {
          scope.selectedItems = [];
          scope.multiSelectEvents.onSelectionChanged();
        }

        if ($select) {
          $event.stopPropagation();
          $event.preventDefault();
          const defaultValue = scope.list.find(item => item[scope.key] === scope.emptyValue);
          $select.selected = defaultValue;
        }

        if (scope.selected !== scope.model.selected) {
          scope.selected = scope.model.selected;
        }

        let cb = scope.onSelectionChange;
        if (cb) {
          cb({ $type: scope.model.selected });
        }
      };

      scope.$watch('selected', function (newValue, oldValue) {
        if (scope.model.selected !== newValue) {
          scope.model.selected = newValue;
          
          if (scope.isMultiSelect && newValue !== oldValue) {
            if (newValue && scope.list) {
              const selectedKeys = String(newValue).split(',');
              scope.selectedItems = scope.list.filter(item => 
                selectedKeys.some(selectedKey => selectedKey.trim() === String(item[scope.key]).trim())
              );
            } else {
              scope.selectedItems = [];
            }
          }
        }
      }, true);

      scope.$watch('model.selected', function () {
        if (scope.model.selected === 0) {
          let keyVal = scope.key;
          let result = _.find(scope.list, { keyVal: scope.model.selected });
          if (result === undefined) {
            scope.model.selected = scope.emptyValue;
          }        
        }
        
        if(scope.onSelectedChanged) {
          scope.onSelectedChanged({selected: scope.model.selected});
        }
      }, true);

      const modalOpenedListener = $rootScope.$on('modal:opened', function() {
        const uiSelectElement = element.find('ui-select');
        if (uiSelectElement.length > 0) {
          const uiSelectController = uiSelectElement.controller('uiSelect');
          if (uiSelectController && uiSelectController.open) {
            uiSelectController.close();
          }
        }
        
        $('.ui-select-container.open').each(function() {
          const ctrl = angular.element(this).controller('uiSelect');
          if (ctrl && ctrl.open) {
            ctrl.close();
          }
        });
      });

      const visibilityHandler = function() {
        if (document.visibilityState === 'hidden') {
          const uiSelectElement = element.find('ui-select');
          if (uiSelectElement.length > 0) {
            const uiSelectController = uiSelectElement.controller('uiSelect');
            if (uiSelectController && uiSelectController.open) {
              safeApply(scope, function() {
                uiSelectController.close();
              });
            }
          }
          
          $('.ui-select-container.open').each(function() {
            const ctrl = angular.element(this).controller('uiSelect');
            if (ctrl && ctrl.open) {
              safeApply(scope, function() {
                ctrl.close();
              });
            }
          });
        }
      };

      document.addEventListener('visibilitychange', visibilityHandler);

      const closeOnScrollHandler = function(event) {
        if (event.target && event.target.closest && event.target.closest('.ui-select-container')) {
          return;
        }

        let closedAny = false;
        $('.ui-select-container.open').each(function() {
          const ctrl = angular.element(this).controller('uiSelect');
          if (ctrl && ctrl.open) {
            ctrl.close();
            closedAny = true;
          }
        });

        if (closedAny) {
          safeApply(scope);
        }
      };

      const closeOnScroll = ngModel.closeOnScroll !== undefined;
      if (closeOnScroll) {
        document.addEventListener('wheel', closeOnScrollHandler, true);
        document.addEventListener('touchmove', closeOnScrollHandler, true);
      }

      scope.$on('$destroy', function() {
        modalOpenedListener();
        document.removeEventListener('visibilitychange', visibilityHandler);
        if (closeOnScroll) {
          document.removeEventListener('wheel', closeOnScrollHandler, true);
          document.removeEventListener('touchmove', closeOnScrollHandler, true);
        }
      });
    }
  };
});


// WEBPACK FOOTER //
// ./src/scripts/directives/dropdownMenu.js